import {
  getFalveyPricingQuoteData,
  getLTLAccessorials,
} from '@store/ltl/services';
import {
  setAccessorialStore,
  setLtlQuoteState,
  setLTLQuotingResultStore,
  setLtlQuotingViewStore,
} from '@store/ltl/store';
import {
  AccessorialState,
  FalveyInsuranceQuote,
  FalveyQuotesPayload,
  LTLQuotingResultState,
} from '@store/ltl/types';
import type { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';
import { produce } from 'solid-js/store';

export const fetchAccessorials = async () => {
  try {
    const resp = await getLTLAccessorials();
    setAccessorialStore(
      produce((draft: AccessorialState) => {
        draft.items = resp ?? [];
        draft.isError = false;
        draft.isLoading = false;
      }),
    );
  } catch (e) {
    setAccessorialStore(
      produce((draft: AccessorialState) => {
        draft.isError = true;
        draft.errorMessage = 'Failed loading LTL Accessorials';
        draft.isLoading = false;
      }),
    );
  }
};

export const getLTLFalveyPricingQuotes = async (
  partialPayload: Partial<FalveyQuotesPayload>,
  hideToastr?: boolean,
  changeTrackingSource?: ChangeTrackingSource,
) => {
  setLtlQuoteState('isLoading', true);
  const payload: Partial<FalveyQuotesPayload> = {
    shipmentTypeID: '139015',
    currency: 'USD',
    shippingMerchandiseDescription: '',
    ...partialPayload,
  };
  try {
    const resp = await getFalveyPricingQuoteData(
      payload as FalveyQuotesPayload,
      hideToastr,
      changeTrackingSource,
    );
    setLtlQuoteState(
      produce((draft) => {
        draft.falveyPricingQuote = resp as FalveyInsuranceQuote;
        draft.isError = false;
        draft.errorMessage = '';
      }),
    );
  } catch (error) {
    setLtlQuoteState(
      produce((draft) => {
        draft.isError = true;
        draft.falveyPricingQuote = undefined;
        draft.errorMessage = 'Failed to get Falvey pricing quotes';
      }),
    );
  } finally {
    setLtlQuoteState('isLoading', false);
  }
};

export const clearLtlQuoteResults = () => {
  setLTLQuotingResultStore(
    produce((draft: LTLQuotingResultState) => {
      draft.items = [];
    }),
  );
};

export const setCurrentLTLQuoteView = (view: 'quote-result' | 'quote-form') => {
  setLtlQuotingViewStore(
    produce((draft) => {
      draft.currentLTLView = view;
    }),
  );
};
